var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.fields),function(field){return _c(field.field,_vm._b({key:field.name,tag:"component",attrs:{"data":field,"disabled":_vm.disabled},model:{value:(_vm.data[field.name]),callback:function ($$v) {_vm.$set(_vm.data, field.name, $$v)},expression:"data[field.name]"}},'component',field.props,false))}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09d60b05","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/fields.vue
// module id = null
// module chunks = 